module.exports = __webpack_public_path__ + "static/media/about_1.17cd939e.svg";